/** @desc Util service to handle pagination functions **/
export class PaginationService {
  /**
   * Function to determine numbers left on a page
   * @param {array} data - Array of datasets to be shown
   * @param {number} total - Total items to be shown
   * @return {number}
   */
  getNumberOfPagesLeft(data: Array<object>, total: number): number {
    var len;
    if (!data || !total) {
      return 0;
    }
    len = data.length;
    return len > 0 ? Math.ceil(total / len - 1) : 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/util/pagination.service.ts